// Product gallery: show only the photos of the selected colour (photos are stored in one block per colour,
// starting at that colour's variant image). Products whose photos are not grouped that way are left alone.
(() => {
  const dataEl = document.getElementById('cp-vg-data');
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const order = data.media.map(String);
  const featured = new Set(Object.values(data.variants).map(String));
  const starts = order.map((id, i) => (featured.has(id) ? i : -1)).filter((i) => i >= 0);
  if (starts.length < 2) return;
  const sizes = starts.map((start, i) => (i + 1 < starts.length ? starts[i + 1] : order.length) - start);
  if (Math.min(...sizes) < 2 || Math.max(...sizes) - Math.min(...sizes) > 1) return;

  const groupOf = {};
  let current = null;
  order.forEach((id, i) => {
    if (starts.includes(i)) current = id;
    groupOf[id] = current; // null = photos before the first colour block, always shown
  });

  let active = null;
  const apply = () => {
    const gallery = document.querySelector('#MainContent media-gallery');
    if (!gallery || !active) return;
    gallery.querySelectorAll('[data-media-id], [data-target]').forEach((item) => {
      const id = (item.dataset.mediaId || item.dataset.target || '').split('-').pop();
      if (!(id in groupOf)) return;
      item.classList.toggle('cp-vg-hide', groupOf[id] !== null && groupOf[id] !== active);
    });
    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  };

  const setVariant = (variantId) => {
    const mediaId = data.variants[String(variantId)];
    const group = mediaId && groupOf[String(mediaId)];
    if (!group || group === active) return;
    active = group;
    apply();
  };

  const form = document.querySelector('#MainContent form[action*="/cart/add"] [name=id]');
  setVariant(new URLSearchParams(location.search).get('variant') || (form && form.value) || data.selected);
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => event.data && event.data.variant && setVariant(event.data.variant.id));
  }
  if (form) form.addEventListener('change', () => setVariant(form.value));
  // Re-apply only when gallery slides are added or moved (Dawn re-renders them on variant change).
  // Text changes such as the slide counter are ignored, and records caused by apply() itself are dropped,
  // so this can never feed itself.
  const gallery = document.querySelector('#MainContent media-gallery');
  if (gallery) {
    const isSlide = (node) => node.nodeType === 1 && (node.matches('[data-media-id], [data-target]') || node.querySelector('[data-media-id], [data-target]'));
    const observer = new MutationObserver((records) => {
      if (!records.some((r) => Array.from(r.addedNodes).some(isSlide))) return;
      apply();
      observer.takeRecords();
    });
    observer.observe(gallery, { childList: true, subtree: true });
  }
})();
